import { useQuery } from '@tanstack/react-query';
import { getActivityFeed } from '../Services/ProcessedTimesheetService';

const useGetActivityFeed = (params, options = {}) =>
    useQuery(['getActivityFeed', params], () => getActivityFeed(params), options);

export default useGetActivityFeed;
